import { Avatar, Tooltip } from "@mui/material";
import AvatarGroup from "@mui/material/AvatarGroup";
import styles from "./AvatarList.module.scss";
import { UserAvatar } from "../../models/workflow.model";

interface Props {
  users: UserAvatar[];
  maxAvatars: number;
}

const AvatarList: React.FC<Props> = ({ users, maxAvatars }) => {
  const visibleUsers = users?.slice(0, maxAvatars);
  const otherUsers = users?.slice(maxAvatars);

  return users != null ? (
    <AvatarGroup max={maxAvatars + 1} className={styles.avatar}>
      {visibleUsers.map((user, index) => (
        <Tooltip title={user.name} key={index}>
          <Avatar className={styles["index" + index]}>{user.initials}</Avatar>
        </Tooltip>
      ))}
      {otherUsers.length > 0 ? (
        <Tooltip
          title={
            <div style={{ whiteSpace: "pre-line" }}>
              {otherUsers.map((x) => x.name).join("\n")}
            </div>
          }
        >
          <Avatar>{"+" + otherUsers.length}</Avatar>
        </Tooltip>
      ) : null}
    </AvatarGroup>
  ) : (
    <></>
  );
};

export default AvatarList;
